import React from "react";
import cn from "classnames";
import { Icon } from "@evidenceb/athena-common/design-system/Icon";
import { useIntl } from "react-intl";
import { playlistMessages } from "../../Teacher/EditPlaylist/playlistMessages";

import "./PlaylistPreview.scss";

type Props = {
    title: string;
    resourcesNb: number;
    className?: string;
};

const PlaylistPreview = ({ title, className, resourcesNb }: Props) => {
    const intl = useIntl();

    return (
        <article className={cn("playlist-preview", className)}>
            <Icon
                path="solo-prof"
                className="playlist-preview__icon"
                size={40}
            />
            <h4>{title}</h4>
            <p className="playlist-preview__detail">
                {resourcesNb} {intl.formatMessage(playlistMessages.resources)}
            </p>
        </article>
    );
};
export default PlaylistPreview;
